/* eslint-disable */
export default {
  notActivated: 'Inativo',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
